export function appSearchMetadata(pathname: string, hostname: string, knownRoute: boolean) {
  const path = pathname.replace(/\/+$/, '') || '/'
  const titles: Record<string, string> = {
    '/': 'ISSEN App — Practice speaking with your AI language tutor',
    '/login': 'Sign in to ISSEN',
    '/subscribe': 'Choose your ISSEN subscription',
    '/manage-account': 'Manage your ISSEN account',
  }
  const referral = /^\/i\/[^/]+$/.test(path)
  const pageName = path.slice(1).replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase())
  const privatePaths = new Set([
    '/subscribe', '/manage-account', '/email', '/password', '/reset-password',
    '/confirmation-code', '/delete-account', '/account-deleted', '/subscribed',
    '/pending-subscription', '/cancelled', '/marketing-feedback', '/marketing-unsubscribe',
  ])
  return {
    title: titles[path] ?? (referral ? 'Practice languages with ISSEN' : `${pageName} | ISSEN`),
    canonical: knownRoute ? `https://app.issen.com${referral || path === '/' ? '/' : path}` : null,
    robots: hostname !== 'app.issen.com' || !knownRoute || referral || privatePaths.has(path)
      ? 'noindex, follow' : 'index, follow',
  }
}

export function updateAppSearchMetadata(path: string, knownRoute: boolean): void {
  const metadata = appSearchMetadata(path, window.location.hostname, knownRoute)
  document.title = metadata.title
  for (const property of ['og:title', 'twitter:title']) {
    document.querySelector<HTMLMetaElement>(`meta[property="${property}"], meta[name="${property}"]`)
      ?.setAttribute('content', metadata.title)
  }
  let robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]')
  if (robots === null) {
    robots = document.createElement('meta')
    robots.name = 'robots'
    document.head.appendChild(robots)
  }
  robots.content = metadata.robots
  let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (metadata.canonical === null) {
    canonical?.remove()
  } else {
    if (canonical === null) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = metadata.canonical
  }
}
